import {AxiosError, AxiosResponse} from 'axios';

import {Mocks} from 'config/mocks';
import {StaticConfig} from 'config/staticConfig';
import {AmicaApiRequest} from 'shared/APIServices/types';

const getQuotingApi = (url: string) => isQuotingApi(url) && StaticConfig.quotingBaseApi;
export const isQuotingApi = (url: string) =>
  url?.includes('/edge/web-quotes') || url?.includes('/websubmission-email/send-quoted-email');
export const isEdgeAPI = (url: string) => url?.includes('/edge/');

export const getMockResponse = async <Data extends {}, Params extends {}, Headers extends {}>(
  amicaApiRequest: AmicaApiRequest<Data, Params, Headers>
) => {
  if (Mocks.Enabled) {
    const {mockApi} = await import(/* webpackChunkName: "mocks" */ 'mocks');
    return mockApi(amicaApiRequest);
  }

  return undefined;
};

export const isAxiosResponse = (response: AxiosResponse | AxiosError): response is AxiosResponse => 'data' in response;

export const getApiSubdomain = (specificApi?: string) => {
  const {baseApi} = StaticConfig;
  const api = specificApi ?? baseApi;
  const preIndex = api.indexOf('//');
  const postIndex = api.indexOf('.apigateway');
  return api && preIndex > 0 && postIndex > 0 ? api.substring(preIndex + 2, postIndex).toUpperCase() : undefined;
};

export const getApiUrl = (url?: string) => (url && getQuotingApi(url)) || StaticConfig.baseApi;
